import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PopConfirmComponent } from '../../core/pop-confirm/pop-confirm.component';
import { NgForm } from '@angular/forms';
import { PickListHeader } from 'src/app/models/PickList/picklist-header';
import { PickListDetail } from 'src/app/models/PickList/picklist-detail';
import { PicklistService } from 'src/app/service/picklist.service';

@Component({
  selector: 'app-picklist-header-form',
  templateUrl: './picklist-header-form.component.html',
  styleUrls: ['./picklist-header-form.component.scss'],
})
export class PickListHeaderFormComponent implements OnInit {
  @Input() currentPicklistHeader: PickListHeader;
  @Output() ShowForm = new EventEmitter<boolean>();

  @Output() submitEmitterCanCloseChildForm = new EventEmitter<any>(); //event permettant d'indiquer que l'enfant (ici) veut se fermer
  @Output() submitEmitterChildHaveChanges = new EventEmitter<any>(); //event permettant d'indiquer que l'enfant (ici) a des changemenets
  @Output() submitEmitterForceRefresh = new EventEmitter<any>();

  @ViewChild(NgForm) myform!: NgForm; //permet d'accéder ici (TS) au FORM fabriqué FrontEnd, nommé MyForm.

  titre: string;
  NomEntiteCourante: string = 'Picklist';
  IsChangesPublished: boolean = false;

  constructor(private dialog: MatDialog, private snack: MatSnackBar, private picklistServices: PicklistService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    //on va essayer de ramasser le ID du projet par la route, si possible (en cas de pop-up, entre autre.. pas obligé)
    let MyPicklistIdByParam = this.route.snapshot.paramMap.get('id');
    //si on recoit un ID par la route, on va instancier le composant actuel
    if (MyPicklistIdByParam) {
      this.currentPicklistHeader = new PickListHeader();
      this.currentPicklistHeader.PickListHeaderID = +MyPicklistIdByParam;
    }
  }

  //méthode permettant de rafraichir les données actuelle
  refreshInterface() {
    //var id = this.route.snapshot.paramMap.get('id');
    if (this.currentPicklistHeader) {
      // EDIT
      this.titre = 'Modifier une PickList';
      // fetch project data
      this.picklistServices.getHeader(this.currentPicklistHeader.PickListHeaderID).subscribe((jsonData) => {
        this.currentPicklistHeader = jsonData;
      });
    } else {
      // ADD
      this.currentPicklistHeader = new PickListHeader();
      this.titre = 'Créer une nouvelle PickList';
    }
  }

  //Evenement de sauvegarde...on encapsule pour gérer si on doit faire un pop-up ou non
  OnSauvegardeClick() {
    //si le formulaire est invalide [des champs required qui sont vides], on va demander à l'usager de confirmer
    if (this.myform.valid === false) {
      // pop dialog
      const dialogRef = this.dialog.open(PopConfirmComponent, {
        data: {
          titre: 'Formulaire avec champ invalide',
          texte: 'Attention!  Certains champs obligatoires ne semblent pas avoir été remplit. <br/><br/>Désirez-vous enregistrer QUAND MÊME?',
          affirmativeActionName: 'Oui, enregistrer quand même',
          affirmativeActionColor: 'primary',

          dismissiveActionName: 'Non, revenir en arrière',
          dismissiveActionColor: 'warn',
        },
      });
      // after close dialog
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.sauvegarder();
        }
      });
    } else {
      //si le modèle était valide dès le début, on enregistre.
      this.sauvegarder();
    }
  }

  //méthode pour enregistrer dans la bd
  sauvegarder() {
    let action = 'sauvegardé';
    //si le projet a un ID, c'estun UPDATe...
    if (this.currentPicklistHeader.PickListHeaderID) {
      // EDIT
      this.picklistServices.updateHeader(this.currentPicklistHeader).subscribe((jsonData) => {
        //on ferme le FORM
        this.cacherForm(true);
        //pop-up...
        this.snack.open(`L'entête no ${jsonData.PickListHeaderID} a été ${action}.`, '', { duration: 3000 });
        this.IsChangesPublished = true;
      });
    } else {
      // ADD
      this.picklistServices.create(this.currentPicklistHeader.NumberOfSplits, this.currentPicklistHeader.OutputType).subscribe((jsonData) => {
        this.currentPicklistHeader = jsonData;
        action = 'ajoutée';

        //on ferme le FORM
        this.cacherForm(true);
        //pop-up...
        this.snack.open('La PickList a été ' + action + '.', '', { duration: 3000 });
        this.IsChangesPublished = true;
      });
    }
  }

  detruire() {
    // pop dialog
    /*const dialogRef = this.dialog.open(PopConfirmComponent, {
     data: {
       titre: 'Supprimer la station',
       texte: 'Êtes-vous sûr de vouloir supprimer ce type de paquet?',
       affirmativeActionName:'Supprimer',
       affirmativeActionColor:'warn',

       dismissiveActionName:'Annuler',
       dismissiveActionColor:'',
     },
   });
   // after close dialog
   dialogRef.afterClosed().subscribe((result) => {
     if (result === true) {
       //si on répond OUI, (affirmative)  on procède à la suppression
        this.myMainService.delete(this.currentItem.id).subscribe((jsonData) => {
          this.cacherForm(true);
          this.snack.open('Le type de paquet a été détruit.', '', { duration: 3000 });
          this.IsChangesPublished = true;
       });
     }
   });*/
    /*On ne peut pas détruire une PickList*/
  }

  annuler() {
    this.cacherForm();
  }

  cacherForm(param_ForceParentRefresh: boolean = false): void {
    this.submitEmitterChildHaveChanges.emit(false); //on raise le event indiquant si l'enfant a des changements en cours (false, ici)
    this.submitEmitterCanCloseChildForm.emit(true); //on raise le Event permettant de demander de se faire fermer
    this.submitEmitterForceRefresh.emit(param_ForceParentRefresh);
  }

  //Détecte N'IMPORTE quel changement sur mon composant
  ngDoCheck(changes: any) {
    let test = changes;

    if (this.myform?.pristine === false && this.IsChangesPublished === false) {
      this.IsChangesPublished = true;
      this.submitEmitterChildHaveChanges.emit(true);
    }
  }

  //ne détecte QUE les changements sur les @input values
  ngOnChanges() {
    this.refreshInterface();
  }
}
